export default "__VITE_ASSET__645916e5__"